import React from 'react';
import { Card, CardContent } from './ui/card';

const PricingSection = () => {
  return (
    <section id="pricing" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 scroll-animate">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Simple <span className="text-red-500">Pricing</span>
          </h2>
        </div>

        <Card className="scroll-animate-scale max-w-2xl mx-auto bg-gradient-to-br from-red-900/20 to-black border-2 border-red-500">
          <CardContent className="p-12 text-center">
            <div className="mb-8">
              <div className="text-6xl font-bold mb-2">
                <span style={{ color: '#FFD700' }}>$75</span>
                <span className="text-white text-3xl">/hour</span>
              </div>
              <p className="text-xl text-gray-300">2-hour minimum</p>
            </div>

            <div className="space-y-4 text-left">
              <p className="text-lg text-gray-300 flex items-center">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                Same-day and scheduled service available
              </p>
              <p className="text-lg text-gray-300 flex items-center">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                Materials reimbursed separately (with approval)
              </p>
              <p className="text-lg text-gray-300 flex items-center">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                No hidden fees
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default PricingSection;
